import React from 'react'
import ALSDownload from "./dialog/alsDownload"

class ALSPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        //ToDO: Subscribe to IFrame Events in here
        window.addEventListener('message', this.gameEventHandler.bind(this), false);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.gameEventHandler);    
    }
   gameEventHandler = (event) => {
        const messageData = event.data || {};
        switch (messageData.trackingEvent) {
            case "finish-evaluation":
                if(this.state.finishGameEventFired === false){
                    this.setState({
                        showPostQuestionnaire: true,
                        finishGameEventFired: true,
                        showNavBar: true, 
                    });
                }
                break;
            default:
                console.log(messageData, "<-- event not found");
                break;
        }
    }

    render() {
        return (
            <div>
                <div className="ls-Window">
                    <ALSDownload    ls={this.props.ls} 
                                    game={this.props.game}
                                    motto={this.props.motto}
                                    moderation={this.props.moderation}
                                    handout={this.props.handout}
                                    konstruktion={this.props.konstruktion}
                                    vorlage={this.props.vorlage} />
                </div>
            </div>
        );
    }
}

export default ALSPageComponent